var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4179 13.0464C34.2539 13.149 30.3499 15.3157 30.3499 20.1197C30.5339 25.5984 35.2766 27.5197 35.3579 27.5197C35.2766 27.6224 34.6419 30.137 32.7619 32.773C31.2699 35.0437 29.6139 37.333 27.0993 37.333C24.7073 37.333 23.8486 35.8197 21.0886 35.8197C18.1246 35.8197 17.2859 37.333 15.0166 37.333C12.5019 37.333 10.7233 34.921 9.14994 32.6717C7.10594 29.7277 5.36861 25.1077 5.30728 20.6717C5.26594 18.321 5.71661 16.0104 6.86061 14.0477C8.47528 11.3077 11.3579 9.4477 14.5059 9.38637C16.9179 9.30503 19.0646 11.0424 20.5366 11.0424C21.9473 11.0424 24.5846 9.38637 27.5686 9.38637C28.8566 9.3877 32.2913 9.7757 34.4179 13.0464ZM20.3326 8.91703C19.9033 6.77037 21.0886 4.6237 22.1926 3.25437C23.6033 1.59837 25.8313 0.474365 27.7526 0.474365C27.8753 2.62103 27.0979 4.72637 25.7086 6.2597C24.4619 7.9157 22.3153 9.16237 20.3326 8.91703Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleBlack);
export default __webpack_public_path__ + "static/media/apple-black.7021efae753e927753a42d8b47a72df6.svg";
export { ForwardRef as ReactComponent };